class MultiStepWizard {
    constructor() {
        this.currentStep = 1;
        this.steps = document.querySelectorAll('.measure-step');
        this.totalSteps = this.steps.length;
        this.selectedData = {};
        this.stepValues = {}; // Store values per step to handle back/forward correctly
        this.nextStep = 0;
        this.prevStep = 0;
        this.init();
    }

    init() {
        const activeStep = document.querySelector('.measure-step.active');
        if (activeStep) {
            this.currentStep = activeStep.dataset.step;
            this.updateButtonVisibility(activeStep);
        }
        this.bindEvents();
    }

    updateButtonVisibility(step) {
        const continueBtn = step.querySelector('.btn-continue');
        if (continueBtn) {
            if (step.querySelectorAll('.measure-input').length > 0) {
                continueBtn.classList.remove('hide');
            } else {
                continueBtn.classList.remove('hide'); // Force show continue if no inputs (per user's previous request maybe, or keep as is)
                // Actually, let's stick to the user's current logic but ensure it's visible if needed.
            }
        }
    }

    // Scans every option selected so far across all steps and returns a
    // normalized mount type ("inside" | "outside" | "") based on the option
    // label text (e.g. "INSIDE MOUNT" / "OUTSIDE MOUNT"). This works
    // regardless of which step position asks the mount question.
    getSelectedMountType() {
        let mountType = '';
        Object.values(this.selectedData).forEach((val) => {
            if (typeof val === 'string') {
                const upper = val.toUpperCase();
                if (upper.indexOf('INSIDE MOUNT') !== -1) {
                    mountType = 'inside';
                } else if (upper.indexOf('OUTSIDE MOUNT') !== -1) {
                    mountType = 'outside';
                }
            }
        });
        return mountType;
    }

    bindEvents() {
        this.steps.forEach(step => {
            step.querySelectorAll('.option-card').forEach(card => {
                card.addEventListener('click', (e) => {
                    const value = e.currentTarget.dataset.value;
                    this.nextStep = e.currentTarget.dataset.next || null;
                    this.selectOption(e.currentTarget, step);
                    this.selectedData[`step_${this.currentStep}`] = value;
                    if(step.querySelectorAll('.measure-input').length == 0){
                        // Store default height for steps without input fields
                        const defaultHeight = parseFloat(e.currentTarget.dataset.defaultHeight) || 0;
                        this.stepValues[this.currentStep] = {
                            width: 0,
                            height: 0,
                            defaultHeight: defaultHeight
                        };
                        this.goToStep(this.nextStep);
                    }
                });
            });

            step.querySelectorAll('.measure-input').forEach(input => {
                input.addEventListener('keyup', (e) => {
                    this.removeError(e.target);
                });
            });

            const backBtn = step.querySelector('.btn-back');
            const continueBtn = step.querySelector('.btn-continue');

            if (backBtn) {
                backBtn.addEventListener('click', () => {
                    if (backBtn.innerText.trim().toUpperCase() === 'RECALCULATE') {
                        this.resetWizard();
                    } else {
                        this.goToStep(this.prevStep, true);
                    }
                });
            }

            if (continueBtn) {
                continueBtn.addEventListener('click', () => {
                    let isValid = true;
                    let crrData = [];
                    let stepWidth = 0;
                    let stepHeight = 0;

                    step.querySelectorAll('.measure-input').forEach(input => {
                        if (!input.value) {
                            input.classList.add('haserror');
                            isValid = false;
                        } else {
                            const val = parseFloat(input.value) || 0;
                            const type = input.dataset.type;

                            if (type === 'width') {
                                stepWidth += val;
                            } else if (type === 'height') {
                                stepHeight += val;
                            }

                            let label = input.attributes.getNamedItem('placeholder').value;
                            let item = {
                                [label]: input.value + ' ' + (input.nextElementSibling ? input.nextElementSibling.innerText : '')
                            }
                            crrData.push(item);
                        }
                    });

                    if (isValid) {
                        // Get default height from active option card
                        const activeCard = step.querySelector('.option-card.active');
                        const defaultHeight = activeCard ? parseFloat(activeCard.dataset.defaultHeight) || 0 : 0;

                        // Store values for this step
                        this.stepValues[this.currentStep] = {
                            width: stepWidth,
                            height: stepHeight,
                            defaultHeight: defaultHeight
                        };

                        if(crrData.length > 0) this.selectedData[`step_${this.currentStep}`] = crrData;

                        if(continueBtn.classList.contains('final')){
                            // Get values from active option card or first card
                            let activeCard = step.querySelector('.option-card.active');
                            if (!activeCard) {
                                activeCard = step.querySelector('.option-card');
                            }
                            let widthVal = 0;
                            let heightVal = 0;
                            if (activeCard) {
                                const widthInput = activeCard.querySelector('.measure-input[data-type="width"]');
                                const heightInput = activeCard.querySelector('.measure-input[data-type="height"]');
                                if (widthInput) widthVal = parseFloat(widthInput.value) || 0;
                                if (heightInput) heightVal = parseFloat(heightInput.value) || 0;
                            }

                            // Determine mount type (inside/outside) from any option selected earlier in the flow.
                            const mountType = this.getSelectedMountType();

                            // Store in sessionStorage so product/quote pages can prefill them
                            if (widthVal > 0) sessionStorage.setItem('calculated_width', widthVal);
                            if (heightVal > 0) sessionStorage.setItem('calculated_height', heightVal);
                            if (mountType) sessionStorage.setItem('calculated_mount', mountType);

                            const url = continueBtn.dataset.url;
                            if (url) {
                                // Build the destination URL dynamically from the wizard's calculated
                                // width/height/mount rather than linking to a static URL.
                                try {
                                    const targetUrl = new URL(url, window.location.origin);
                                    if (widthVal > 0) targetUrl.searchParams.set('width', widthVal);
                                    if (heightVal > 0) targetUrl.searchParams.set('height', heightVal);
                                    if (mountType) targetUrl.searchParams.set('mount', mountType);
                                    window.location.href = targetUrl.pathname + targetUrl.search;
                                } catch (e) {
                                    // Fallback if URL constructor fails
                                    let separator = url.includes('?') ? '&' : '?';
                                    let newUrl = url;
                                    if (widthVal > 0) {
                                        newUrl += separator + 'width=' + widthVal;
                                        separator = '&';
                                    }
                                    if (heightVal > 0) {
                                        newUrl += separator + 'height=' + heightVal;
                                        separator = '&';
                                    }
                                    if (mountType) {
                                        newUrl += separator + 'mount=' + mountType;
                                    }
                                    window.location.href = newUrl;
                                }
                            } else {
                                alert("Redirection URL is not configured.");
                            }
                            return;
                        }

                        let activeOptionCards = step.querySelectorAll('.option-card.active');
                        if (activeOptionCards.length === 0) {
                            const firstCard = step.querySelector('.option-card');
                            if (firstCard) {
                                firstCard.classList.add('active');
                                activeOptionCards = [firstCard];
                            }
                        }
                        activeOptionCards.forEach(card => {
                            this.nextStep = card.dataset.next || null;
                        });

                        if (this.nextStep) {
                            this.goToStep(this.nextStep);
                        }
                    }
                });
            }
        });
    }

    resetWizard() {
        this.stepValues = {};
        this.selectedData = {};
        const firstStep = this.steps[0].dataset.step;
        this.goToStep(firstStep);
    }

    removeError(input) {
      input.classList.remove('haserror');
    }

    selectOption(card, step) {
        step.querySelectorAll('.option-card').forEach(otherCard => {
            otherCard.classList.remove('active');
        });
        card.classList.add('active');
    }

    goToStep(stepNumber, isBack = false) {
        this.steps.forEach(step => step.classList.remove('active'));
        const targetStep = document.querySelector(`[data-step="${stepNumber}"]`);
        if (targetStep) {
            window.scrollTo(0, 60);
            targetStep.classList.add('active');
            this.prevStep = targetStep.dataset.prev;
            this.currentStep = stepNumber;
            this.updateButtonVisibility(targetStep);

            if(targetStep.classList.contains('final')){
                // Calculate totals
                let totalWidth = 0;
                let totalHeight = 0;
                Object.values(this.stepValues).forEach(vals => {
                    totalWidth += vals.width;
                    totalHeight += (vals.height + (vals.defaultHeight || 0));
                });

                let counter = 0;
targetStep.querySelectorAll('.measure-input').forEach(input => {
    input.readOnly = true;
    const type = input.dataset.type;
    if (type === 'width') {
        if(counter > 0){
            const roundedWidth = Math.round((totalWidth / 2) * 100) / 100;
            input.value = Number.isInteger(roundedWidth) ? roundedWidth.toString() : roundedWidth.toFixed(2);
        }else{
            input.value = totalWidth;
        }
        counter++;
    } else if (type === 'height') {
        const roundedHeight = Math.round(totalHeight * 100) / 100;
        input.value = Number.isInteger(roundedHeight) ? roundedHeight.toString() : roundedHeight.toFixed(2);
    }
});
            } else {
                targetStep.querySelectorAll('.measure-input').forEach(input => {
                    input.readOnly = false;
                });
            }
        }
    }


}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    new MultiStepWizard();
    if (document.documentElement.classList.contains('shopify-design-mode')) {
        const meaturnElement = document.getElementById('measure-page-container');
        if (meaturnElement) {
            meaturnElement.classList.add('editmode');
        }
    }
});
